<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Veículos do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap> CÓD. COTAÇÃO ENDOSSO </v-flex>
        <v-flex> N. PROPOSTA / ENDOSSO </v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO </v-flex>
        <v-flex>RAZÃO SOCIAL </v-flex>
        <v-flex> CNPJ </v-flex>
        <v-flex> QTD. ÍTENS INCLUSÃO </v-flex>
        <v-flex> VLR.ENDOSSO </v-flex>
        <v-flex>
          <br />
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-btn
            v-if="selected && !camposDisabled"
            color="primary"
            round
            dark
            @click="dialog = true"
            >{{ textoBotaoAcao }}</v-btn
          >
        </v-card-title>
      </v-card>

      <template>
        <div class="table-width">
          <v-data-table
            :headers="headers"
            :items="errosFiltrados"
            :search="filtro.pesquisa.conteudo"
            :pagination.sync="pagination"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="__rowKey"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td
                :class="{
                  'linha-original-modificada': props.item.isOriginalModificado,
                  'linha-nova-modificada': props.item.isModificado
                }"
              >
              <v-checkbox
                class="checkbox"
                color="primary"
                hide-details
                :value="props.item && selected && props.item.__rowKey === selected.__rowKey"
                @change="value => (selected = value ? props.item : null)"
                :disabled="
                  camposDisabled ||
                  props.item.isOriginalModificado === true
                "
              ></v-checkbox>
              </td>

              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                class="themeGrey--text click"
                :class="{
                  'linha-original-modificada': props.item.isOriginalModificado,
                  'linha-substituto': props.item.isModificado,}"
              >
                {{ texto }}
              </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua pesquisa não foi encontrada.
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex d-flex justify-center>
        <v-btn class="button-custom" @click="proximo()" flat> Próximo </v-btn>
      </v-flex>
    </v-layout>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogAvaliando" max-width="800px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">AVALIANDO ITENS</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12>
                    <span>
                      Por favor, aguarde o processamento. Isso pode levar alguns
                      minutos
                    </span>
                  </v-flex>
                  <v-flex align-center d-flex xs12>
                    <v-progress-linear
                      heigth="2px"
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogAvaliando = false"
                >CANCELAR
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" hide-overlay fullscreen>
          <AdicionarItemEndossoModal
            v-if="dialog"
            @add="adicionarModificacaoItem($event), (dialog = false)"
            :item="proximoIndice"
            :dialog="dialog"
            @fechar="dialog = false"
            :campos="campos"
            :alterarValores="true"
            :placa="placaSelecionada"
            :chassi="chassiSelecionado"
            :chassis="chassisValidacao"
            :modificacoes="modificacoesItem()"
            :edicaoSubstituto="editandoSubstituto"
            diferencaObjetos
          />
        </v-dialog>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import AdicionarItemEndossoModal from "./AdicionarItemEndossoModal";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";

export default {
  name: "GridEndossoVeiculosSubstituicao",
  components: {
    AdicionarItemEndossoModal,
  },
  data() {
    return {
      idStatusEndosso: null,
      idPropostaStatus: null,
      idApolice: null,
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: "",
      },
      conteudoPlanilha: null,
      itemRemovidoList: [],
      dialogProgress: false,
      idTipoEndosso: null,
      arquivoFaltante: [],
      arquivoValido: true,
      arquivo: {},
      loading: false,
      filtrarErros: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogAvaliando: false,
      pagination: {
        sortBy: "name",
      },
      selected: null,
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
      },
      campos: {
        numeroRevisao: null,
        erroPlanilha2: null,
        listaEstados: [],
        tipoVeiculoList: [],
        catVeiculoList: [],
        ufPernoiteList: [],
        usoDoVeiculoList: [],
        propriedadeRegistroDoCrlvList: [],
        diasGarantZeroKmList: [],
        tipoCoberturaList: [],
        tipoDeContratacaoList: [],
        tipoDeFranquiaList: [],
        tipoDePropostaList: [],
        ciaRenovacaoList: [],
        kmAssistenciaList: [],
        carroReservaList: [],
        descrCarroceriaList: [],
        descrEquipamentosList: [],
        descrAcessoriosList: [],
        coberturaVidrosList: [],
        codigoSistemaRastreamentoList: [],
        vlrFranquiaDanosMateriaisList: [],
        vlrFranquiaGarantiaUnicaList: [],

        classeList: new Array(11).fill({}).map((_, index) => ({
          id: index,
          titulo: `${index}`,
        })),
        renovacaoSinistroOptions: [
          {
            id: true,
            titulo: "Com sinistro",
          },
          {
            id: false,
            titulo: "Sem Sinistro",
          },
        ],
      },
      resultados: {
        totalPremio: null,
      },
      headers: [
        { text: "", value: "", notSortable: false, class: "pa-0" },
        { text: "ITEM", align: "center", value: "item" },
        {
          text: "PLACA",
          align: "center",
          value: "placa",
        },
        { text: "CHASSI", align: "center", value: "chassi" },
        { text: "FIPE", align: "center", value: "fipe", style: "width: 100px" },
        { text: "MARCA", align: "center", value: "marca" },
        { text: "MODELO ", align: "center", value: "modelo" },
        { text: "TIPO VEÍCULO", align: "center", value: "tipoVeiculo" },
        { text: "CAT. VEÍCULO", align: "center", value: "catVeiculo" },
        { text: "ANO FAB.", align: "center", value: "anoFab" },
        { text: "ANO MOD.", align: "center", value: "anoMod" },
        { text: "UF PERNOITE", align: "center", value: "ufPernoite" },
        { text: "USO DO VEÍCULO", align: "center", value: "usoDoVeiculo" },
        {
          text: "PROPRIEDADE (REGISTRO DO CRLV)",
          align: "center",
          value: "propriedadeRegistroDoCrlv",
        },
        { text: "PROPRIETÁRIO", align: "center", value: "proprietario" },
        { text: "CPF/CNPJ", align: "center", value: "cpfCnpj" },
        { text: "NOME SOCIAL", align: "center", value: "nomeSocial" },
        { text: "CHASSI REMARCADO", align: "center", value: "chassiRemarcado" },
        { text: "ZERO KM", align: "center", value: "zeroKm" },
        { text: "SAÍDA CONCESSIONÁRIA", align: "center", value: "saidaDaConcessionaria" },
        { text: "QUANT PASSAGEIROS", align: "center", value: "quantPassageiro" },
        { text: "DISPOSITIVO DE SEGURANÇA", align: "center", value: "codigoSistemaRastreamento"},
      ],
      dadosPlanilha: [],
      chassis: [],
      chassiQtdPassageiros: []
    };
  },
  computed: {
    ...mapState("formEndosso", [
      "id",
      "proponenteCnpj",
      "proponenteRazaoSocial",
    ]),
    quantidadeItens() {
      return this.$store.getters["formEndosso/quantidadeItem"];
    },

    camposDisabled() {
      return (
        (this.idStatusEndosso > statusEndossoEnum.statusEndosso.SALVO &&
          this.idStatusEndosso != statusEndossoEnum.statusEndosso.PENDENTE) ||
        this.idPropostaStatus == 7
      );
    },

    mostrarBotaoReavaliar() {
      if (this.selected) {
        return false;
      }
      return !!this.erroPlanilha[this.selected.item];
    },
    errosFiltrados() {
      return this.filtrarErros && this.numeroErros
        ? this.dadosPlanilha.filter((value) => value.erro)
        : this.dadosPlanilha;
    },
    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },

    proximoIndice() {
      return (
        this.dadosPlanilha.reduce(
          (acc, cur) => (cur.item > acc ? cur.item : acc),
          -1
        ) + 1
      );
    },

    editandoSubstituto() {
      return !!(this.selected && this.selected.isModificado);
    },

    textoBotaoAcao() {
      return this.editandoSubstituto ? "Editar Substituto" : "Substituir";
    },

    linhaOriginalSelecionada() {
      if (!this.editandoSubstituto) {
        return null;
      }
      const itemOriginal =
        this.selected.itemOriginal != null
          ? this.selected.itemOriginal
          : this.selected.item;
      return (
        this.dadosPlanilha.find(
          (e) => !e.isModificado && e.item === itemOriginal
        ) || null
      );
    },

    placaSelecionada() {
      const original = this.linhaOriginalSelecionada;
      if (original) {
        return original.placa;
      }
      return this.selected ? this.selected.placa : null;
    },

    itemSelecionado() {
      return this.selected ? this.selected.item : null;
    },

    chassiSelecionado() {
      const original = this.linhaOriginalSelecionada;
      if (original) {
        return original.chassi;
      }
      return this.selected ? this.selected.chassi : null;
    },

    chassisValidacao() {
      const rowKeyEmEdicao = this.editandoSubstituto
        ? this.selected.__rowKey
        : null;
      return this.dadosPlanilha
        .filter((e) => !rowKeyEmEdicao || e.__rowKey !== rowKeyEmEdicao)
        .map((e) => e.chassi);
    }

  },

  mounted() {
    this.idTipoEndosso = parseInt(this.$route.query.idTipoEndosso);
    this.numeroRevisao = this.$route.query.numeroRevisao ? this.$route.query.numeroRevisao : null;
    this.idApolice = this.$route.query.id;
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.idPropostaStatus = this.$route.query.idPropostaStatus
      ? this.$route.query.idPropostaStatus
      : null
    this.idStatusEndosso = this.$route.query.idStatusEndosso ? this.$route.query.idStatusEndosso : null;

    this.dadosPlanilha = this.$store.getters["formEndosso/cloneConteudoPlanilha"];
    this.normalizarLinhasSubstituicao();

    this.buscaOpcoes();
    if (this.$route.query.idRascunhoEndosso == undefined) {
      return this.buscarEndosso();
    }

  },
  methods: {
    rowClass(item) {
      if (item.isOriginalModificado) {
        return 'linha-original-modificada';
      }

      if (item.isModificado) {
        return 'linha-nova-modificada';
      }

      return '';
    },
    async buscarNumPassageiro(chassis){
      const chassiModel = {
        chassis: chassis
      }
      var response = await axios.post(
        `${process.env.URL_APOLICEMS}/v1/buscarNumeroPassageiro/`,chassiModel,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.chassiQtdPassageiros = response.data

    },
    buscarEndosso() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/visualizarApolice/` +
            this.idApolice +
            `/?page=${(this.pagination.page || 1) - 1}&size=${this.pagination.rowsPerPage || 10}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          this.dadosPlanilha = response.data.itemCotacaoList;
          this.aplicarModificacoes();
          this.$store.commit("endLoading");
        })
        .catch((err) => {
          this.$store.commit("endLoading");
        });
    },

    colunas(item) {
      const valor = (key) => {
        if (item.modificacoes) {
          if (item.modificacoes.hasOwnProperty(key)) {
            return item.modificacoes[key]
          }
        }
        return item[key]
      }
      return [
        [this.formatarNumeroItem(valor("item")), { class: "pa-4 text-align-center" }],
        [valor("placa") || '-', { class: "text-align-center" }],
        [valor("chassi") || '-', { class: "pa-4 text-align-center" }],
        [valor("fipe") || '-', { class: "pa-4 text-align-center" }],
        [valor("marca") || '-', { class: "pa-4 text-align-center" }],
        [valor("modelo") || '-', { class: "text-align-center" }],
        [this.traduzValorObjeto(valor("tipoVeiculo")), { class: "text-align-center" }],
        [this.traduzValorObjeto(valor("catVeiculo")), { class: "text-align-center" }],
        [valor("anoFab") || '-', { class: "text-align-center" }],
        [valor("anoMod") || '-', { class: "text-align-center" }],
        [this.traduzValorObjeto(valor("ufPernoite")), { class: "text-align-center" }],
        [this.traduzValorObjeto(valor("usoDoVeiculo")), { class: "text-align-center" }],
        [this.traduzValorObjeto(valor("propriedadeRegistroDoCrlv")), { class: "text-align-center" }],
        [valor("proprietario") || '-', { class: "text-align-center" }],
        [valor("cpfCnpj") || '-', { class: "text-align-center" }],
        [valor("nomeSocial") || '-', { class: "text-align-center" }],
        [this.traduzValor(valor("chassiRemarcado")), { class: "text-align-center" }],
        [this.traduzValor(valor("zeroKm")), { class: "text-align-center" }],
        [valor("saidaDaConcessionaria") || '-', { class: "text-align-center" }],
        [this.buscarQuantPassageiro(item.chassi) !== undefined ? this.buscarQuantPassageiro(item.chassi):valor("quantPassageiro"), { class: "text-align-center" }],
        [this.traduzValorObjeto(valor("codigoSistemaRastreamento")), { class: "text-align-center" }],
      ];
    },
    buscarQuantPassageiro(chassi){
      for(var quant of this.chassiQtdPassageiros){
        if(quant.nrChassi === chassi){
          return quant.nrQtdPax
        }
      }

    },

  modificacoesItem() {
      if (this.selected && this.selected.modificacoes) {
        return this.selected.modificacoes;
      }

      if (this.editandoSubstituto) {
        return this.dadosDoSubstituto(this.selected);
      }
      return null;
    },

    dadosDoSubstituto(linha) {
      const ignorar = [
        "isModificado",
        "isOriginalModificado",
        "itemOriginal",
        "camposModificados",
        "modificacoes",
        "__rowKey",
        "erro",
        "id",
      ];
      const dados = {};
      Object.keys(linha).forEach((key) => {
        if (ignorar.indexOf(key) === -1 && linha[key] !== undefined) {
          dados[key] = linha[key];
        }
      });
      dados.item =
        linha.itemOriginal != null ? linha.itemOriginal : linha.item;
      return dados;
    },

    normalizarLinhasSubstituicao() {
      const grupos = {};

      this.dadosPlanilha.forEach((linha) => {
        if (!grupos[linha.item]) grupos[linha.item] = [];
        grupos[linha.item].push(linha);
      });

      Object.keys(grupos).forEach((chave) => {
        const lista = grupos[chave];

        if (lista.length < 2) {
          this.$set(lista[0], "__rowKey", `${chave}-original`);
          return;
        }

        const original = lista.find((e) => !e.isModificado) || lista[0];
        const substituto =
          lista.find((e) => e.isModificado && e !== original) ||
          lista.find((e) => e !== original);

        this.$set(original, "isModificado", false);
        this.$set(original, "isOriginalModificado", true);
        this.$set(original, "__rowKey", `${chave}-original`);

        this.$set(substituto, "isModificado", true);
        this.$set(substituto, "isOriginalModificado", false);
        this.$set(substituto, "itemOriginal", original.item);
        this.$set(substituto, "__rowKey", `${chave}-modificado`);
      });
    },

    submeterArquivo() {
      this.loading = true;
      const formData = new FormData();
      formData.append("planilha", this.arquivo);
      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/validarPlanilha`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          this.arquivoValido =
            typeof response.data.valido === "boolean"
              ? response.data.valido
              : true;
          this.arquivoFaltante =
            response.data.naoEncontrados instanceof Array
              ? response.data.naoEncontrados
              : [];
          this.conteudoPlanilha =
            response.data.conteudo instanceof Array
              ? response.data.conteudo
              : [];
          this.erroPlanilha2 =
            response.data.erros instanceof Array ? response.data.erros : [];
          if (this.arquivoValido) {
            this.avaliarPlanilha();
          }
        })
        .catch((err) => {
          this.arquivoValido = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    atualizarGrid() {
      this.$store.commit("formEndosso/setConteudoPlanilha", {
        dados: this.conteudoPlanilha.map((e) => {
          const item = this.erroPlanilha2.find((v) => v.item === e.item);
          return { ...e, erro: item && item.erro };
        }),
      });
      this.$store.commit("formEndosso/setErroPlanilha", {
        dados: this.erroPlanilha2,
      });
    },

    formatarErro(novosErros, listaErros = {}) {
      return {
        ...listaErros,
        ...novosErros.reduce(
          (acc, cur) => ({ ...acc, [cur.item]: cur.erro }),
          {}
        ),
      };
    },
    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
    },
    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";
      else if (idTipoEndosso == 2) return "RESTITUIÇÃO";
      else if (idTipoEndosso == 3) return "SEM MOVIMENTAÇÃO";
      else if (idTipoEndosso == 4) return " CANCELAMENTO";
      else if (idTipoEndosso == 5) return " SUBSTITUIÇÃO";
    },

    buscarTitulo(entity, list) {
      if (entity) {
        const campo = list.find(
          (item) => item === entity.id || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    aplicarModificacoes() {
      const modificados = this.$store.state.formEndosso.itemModificadoList;

      const novaLista = [...this.dadosPlanilha];

      modificados.forEach((mod) => {
        this.adicionarModificacao(mod, novaLista);
      });

      this.dadosPlanilha = novaLista;
      this.normalizarLinhasSubstituicao();

      this.chassis = this.dadosPlanilha.map(e => e.chassi);

      this.buscarNumPassageiro(this.chassis);
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    saveErro(item) {
      this.save();
      item.erro = true;
    },

    saveErro(item) {
      this.save();
      item.erro = true;
    },

    adicionarModificacaoItem(itemModificado) {
      const novaLista = [...this.dadosPlanilha];
      this.adicionarModificacao(itemModificado, novaLista);
      this.dadosPlanilha = novaLista;
      this.normalizarLinhasSubstituicao();
      this.chassis = this.dadosPlanilha.map((e) => e.chassi);
      this.selected = null;
    },

    adicionarModificacao(itemModificado, lista) {
      if (!itemModificado) return;

      const indexOriginal = lista.findIndex(
        (e) => e.item === itemModificado.item && !e.isModificado
      );
      if (indexOriginal === -1) return;

      const itemOriginal = lista[indexOriginal];

      const chassiDuplicado = lista.some((e, index) => {
        if (index === indexOriginal) return false;

        if (e.isModificado && e.itemOriginal === itemOriginal.item) return false;

        return e.chassi && itemModificado.chassi && e.chassi === itemModificado.chassi;
      });

      if (chassiDuplicado) {
        return;
      }

      const indexModificadoExistente = lista.findIndex(
        (e) => e.isModificado && e.itemOriginal === itemOriginal.item
      );

      this.$set(itemOriginal, 'isOriginalModificado', true);
      this.$set(itemOriginal, '__rowKey', `${itemOriginal.item}-original`);

      const itemModificadoLinha = {
        ...itemOriginal,
        ...itemModificado,
        modificacoes: itemModificado,
        isModificado: true,
        isOriginalModificado: false,
        itemOriginal: itemOriginal.item,
        __rowKey: `${itemOriginal.item}-modificado-${Date.now()}`
      };

      if (indexModificadoExistente !== -1) {
        lista.splice(indexModificadoExistente, 1, itemModificadoLinha);
      } else {
        lista.splice(indexOriginal + 1, 0, itemModificadoLinha);
      }
    },

    filtroFunctions: function () {
      const self = this;
      return {
        abrirFiltroPesquisa: function () {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function () {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        },
      };
    },

    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "tipoVeiculoList",
            "catVeiculoList",
            "ufPernoiteList",
            "usoDoVeiculoList",
            "propriedadeRegistroDoCrlvList",
            "diasGarantZeroKmList",
            "tipoCoberturaList",
            "tipoDeContratacaoList",
            "tipoDeFranquiaList",
            "tipoDePropostaList",
            "ciaRenovacaoList",
            "kmAssistenciaList",
            "carroReservaList",
            "descrCarroceriaList",
            "descrEquipamentosList",
            "descrAcessoriosList",
            "coberturaVidrosList",
            "codigoSistemaRastreamentoList",
            "vlrFranquiaDanosMateriaisList",
            "vlrFranquiaGarantiaUnicaList",

          ].forEach((nome) => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
              if(nome === 'ciaRenovacaoList' || nome === 'carroReservaList'
                || nome === 'descrCarroceriaList' || nome === 'descrEquipamentosList' || nome === 'descrAcessoriosList'
               || nome === 'coberturaVidrosList'){
                response.data[nome].push({id:0,titulo:'Nenhum'});
              }
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    traduzValorObjeto(value) {
      if (value) {
        return value.titulo;
      } else {
        return '-';
      }
    },

    validaColunas() {
      return Object.values(this.erros).every((item) =>
        Object.values(item).every((subItem) => subItem.erro !== true)
      );
    },

    voltar: function () {
      if (this.numeroRevisao != null) {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&numeroRevisao=${this.numeroRevisao}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else if (this.idRascunhoEndosso) {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idRascunhoEndosso=${this.idRascunhoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      }
    },
    proximo() {
      const dadosAtualizados = {
        dados: this.errosFiltrados,
      };

      /* Verifica se o campo Modelo tem mais de 65 caracteres */
      for (var item of dadosAtualizados.dados) {
        if (item.modelo.length > 65) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `[Erro no item ${item.item}] O campo 'Modelo' não pode ultrapassar os 65 caracteres.`;
        return;
        }
      }
      /* -------------------------------------------- */

      this.$store.commit("formEndosso/setItensAdicionados", dadosAtualizados);

      if (this.numeroRevisao != null) {
        this.$router.push(
          `/GridPrincipal/CoberturaEndossoSubstituicao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      } else if (this.idRascunhoEndosso) {
        this.$router.push(
          `/GridPrincipal/CoberturaEndossoSubstituicao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idRascunhoEndosso=${this.idRascunhoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else {
        if (this.idTipoEndosso == 5) {
          this.$router.push(
            `/GridPrincipal/CoberturaEndossoSubstituicao?id=${this.idApolice}${
              this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
            }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
              this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
            }`
          );
        } else {
          this.$router.push(
            `/GridPrincipal/CoberturaEndossoSubstituicao?id=${this.idApolice}${
              this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
            }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
              this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
            }`
          );
        }
      }
    },

    comparador(itemLista, item) {
      if (item && item.id) {
        return item.id === itemLista.id;
      }
      return false;
    },

    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    },
  },
};
</script>

<style>
.background {
  background-color: white;
}

.table-width > div > div > table {
  width: 3000px;
}

.item-color > div > a {
  color: #757575 !important;
}

.activeError {
  border: 1px solid red;
  color: red !important;
}

.button-permanecer {
  background: #00456e;
  color: white !important;
}

.text-permanecer {
  font-weight: bold;
  color: #757575 !important;
}
.errorTaxa {
  color: red !important;
  font-weight: bold;
}

.table-grid thead {
  background-color: #00456e;
}
.table-grid .column {
  color: #fff !important;
}

.table-grid th i {
  color: #fff !important;
}

.dialog {
  background: #eaeaea !important;
}

.headline {
  color: #fff;
  font-size: 14px !important;
}

.text-error {
  color: #f45353;
  font-weight: bold;
}

.name-arquivo {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 2px;
}

input[type="file"] {
  display: none;
}

.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}
.button-customizado {
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 3px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

.button-custom:hover {
  background-color: #063f57;
}

.disabled,
.v-btn.button-custom:disabled {
  cursor: default;
  background-color: #063f57;
  color: #aaaaaa !important;
}

.disabled:hover {
  background-color: #063f57;
}

.click {
  cursor: pointer;
}

.size {
  size: 1;
}

.text-align-center {
  text-align: center;
}

.linha-original-modificada {
  box-shadow: inset 0 0 0 9999px #ff9a9a;
  color: #ffffff !important;
}

.linha-substituto {
  background-color: #e6f2ea;
  font-weight: 500;
}

.linha-nova-modificada {
  position: relative;
}

.linha-nova-modificada::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-color: #e06565;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/GridEndossoVeiculoSubstituicao.vue